module.exports = __webpack_public_path__ + "952e3822d225acd0196c78b9d2ea55b5.png";